// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".etn_menu .active[data-v-db954334]{background:#686868}.etn_menu .active .etn_hide[data-v-db954334],.etn_menu .active a .svg[data-v-db954334]{color:#fff!important}@media (max-width:799px){.edicion_top_nav .etn_menu>li.btn-success_container[data-v-db954334],.edicion_top_nav .etn_menu>li>a.btn-success[data-v-db954334]{min-width:80px!important;width:80px!important}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
